import React from 'react';
import { Chip, Tooltip } from '@mui/material';

export default function PatientV2Badge() {
  return (
    <Tooltip title="Has v2 patient information">
      <Chip
        label="v2"
        size="small"
        variant="outlined"
        sx={{ fontSize: '0.6rem', height: 16, color: 'text.secondary', borderColor: 'divider' }}
      />
    </Tooltip>
  );
}
